import React from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Baget from 'evcharging/components/Baget';
import Spacer from 'evcharging/components/Spacer';
import OccpHeader from 'evcharging/containers/ocpp/OccpHeader';
import Responsible from 'evcharging/components/Responsible';
import Paragraph from 'evcharging/components/Paragraph';
import LinkButton from 'evcharging/components/LinkButton';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import Mobile from 'evcharging/components/Mobile';
import useI18n from 'evcharging/hooks/useI18n';

const Significance = () => {
  const { t } = useI18n();

  return (
    <Section>
      <Container>
        <Spacer value={50} mobile={90} />
        <Baget>{t('ocpp.label')}</Baget>
        <Spacer value={24} />
        <OccpHeader>{t('ocpp.header')}</OccpHeader>
        <Spacer value={24} />
        <Responsible fractions={[49, 49]}>
          <Paragraph color={'middle'}>{t('ocpp.intro1')}</Paragraph>
          <Paragraph color={'middle'}>{t('ocpp.intro2')}</Paragraph>
        </Responsible>
        <Mobile>
          <LinkButton href={CONTACT_US_ANCHOR}>{t('ocpp.schedule')}</LinkButton>
        </Mobile>
        <Spacer value={171} mobile={144} />
      </Container>
    </Section>
  );
};

export default Significance;
